import type { RoboticMowersSummaryItem } from '@fleet-bffs/api-contract';
import type { RoboticMowersSummaryFootprintItem } from '../models/RoboticMowersSummaryFootprintItem';
export const defaultState: Fields = {
  isLoading: false,
  items: [],
};

export interface Fields {
  isLoading: boolean;
  footprintsChangedTimestamp?: number;
  footprintsItems?: RoboticMowersSummaryFootprintItem[];
  items: RoboticMowersSummaryItem[];
}
